<template>
  <div class="bg-main d-flex flex-column h-100">
    <HeaderAuth />
    <div class="d-flex justify-center">
      <div class="registration-card text-center large">
        <h2 class="registration-card__title mb-8">Регистрация</h2>
        <div class=" tab">
          <div class="tab__header">
            <v-tabs
              v-model="currentForm"
              active-class="active_tab"
              :color="'primary'"
              :centered="true"
              hide-slider
            >
              <v-tab
                v-for="(item,idx) in forms"
                :key="idx"
                class="item"
              >
                {{item.title}}
              </v-tab>
            </v-tabs>
          </div>

          <v-tabs-items v-model="currentForm" class="tab__content">
            <v-tab-item
              v-for="(item,idx) in forms"
              :key="idx"
            >
              <component :is="item.component"/>
            </v-tab-item>
          </v-tabs-items>
        </div>
        <div class="mt-8 font-weight-600">
          Уже есть аккаунт?
          <router-link
            class="text-primary"
            to="/login"
            exact
          >
            Войти
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { email, maxLength, required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/common/constants/errorMessages';
import HeaderAuth from '@/components/headers/HeaderAuth'; // import { ADMIN, MANAGER } from '@/common/constants/userTypes';
import { EMAIL } from '@/common/constants/validations';
import { startSpacesValidation } from '@/common/validationHelpers';
import RegistrationClient from '@/components/registration/registrationClient.vue';
import RegistrationCorpClient from '@/components/registration/registrationCorpClient.vue';

export default {
  name: 'Login',
  metaInfo: {
    title: 'Авторизация',
  },
  components: {
    RegistrationCorpClient,
    RegistrationClient,
    HeaderAuth,

  },
  validations: {
    username: {
      required, email, maxLength: maxLength(EMAIL.MAX_LENGTH),
    },
    password: { required, startSpacesValidation },
  },
  data: () => ({
    showPass: false,
    username: '',
    password: '',
    currentForm: null,
    forms: [
      {
        id: 0,
        title: 'Физическое лицо',
        value: 'client',
        component: RegistrationClient
      },
      {
        id: 1,
        title: 'Корпоративный клиент',
        value: 'corpClient',
        component: RegistrationCorpClient
      }
    ],
  }),
  computed: {
    ...mapGetters({
      user: 'auth/user',
      loggedIn: 'auth/loggedIn',
      loading: 'auth/loading',
      errors: 'auth/errors',
    }),
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      if (!this.$v.username.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.username.email) errors.push(MESSAGES.INCORRECT_EMAIL);
      if (!this.$v.username.maxLength) errors.push(MESSAGES.MAX_LENGTH(EMAIL.MAX_LENGTH));

      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.startSpacesValidation) errors.push(MESSAGES.START_SPACES);
      if (!this.$v.password.required) errors.push(MESSAGES.REQUIRED);
      return errors;
    },
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      clearError: 'auth/clearError',
    }),
    onInput(field) {
      this.$v[field].$touch();
      if (this.errors.length) this.clearError();
    },
    async submit() {
      if (this.loading) return;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.login({ username: this.username, password: this.password });
        this.$router.push({ name: 'list-services' }).catch(() => {});
      }
    },
  },
  watch: {
    user() {
      // if (this.user.user_type === ADMIN) {
      //   return this.$router.push({ name: 'managers' }).catch(() => {});
      // }
      // if (this.user.user_type === MANAGER) {
      //   return this.$router.push({ name: 'candidates' }).catch(() => {});
      // }
      // this.$router.push({ name: 'profile' }).catch(() => {});
    },
  },
  beforeDestroy() {
    this.clearError();
  },
};
</script>
